export function changeDateMonth(date: Date, isNextMonth: boolean): Date {
  if (date.getMonth() === 0 && !isNextMonth) {
    return new Date(date.getFullYear() - 1, 11);
  }

  if (date.getMonth() === 11 && isNextMonth) {
    return new Date(date.getFullYear() + 1, 0);
  }

  return new Date(date.getFullYear(), isNextMonth ? date.getMonth() + 1 : date.getMonth() - 1);
}

export interface CalendarCell {
  text: string;
  value: Date;
  isActiveMonth: boolean;
  isValidDate: boolean;
}

const getCalendarCells = (date: Date, currentDate: Date): CalendarCell[] => {
  const daysInMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
  const calendarCells: CalendarCell[] = [];
  const firstDayInMonth = new Date(date.getFullYear(), date.getMonth(), 1).getDay();

  const prepareCell = (date: Date, dayNumber: number, isActiveMonth: boolean, isValidDate: boolean) => {
    return {
      text: String(dayNumber),
      value: new Date(date.getFullYear(), date.getMonth(), dayNumber),
      isActiveMonth,
      isValidDate,
    };
  };

  for (let i = 0; i < daysInMonth; i += 1) {
    const validDate =
      new Date(date.getFullYear(), date.getMonth(), i + 1).getTime() >=
      new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate()).getTime();

    calendarCells.push(prepareCell(date, i + 1, true, validDate));
  }

  const cellsToAppend = 35 - daysInMonth - firstDayInMonth;
  const yearLastMonth = new Date(date.getFullYear(), date.getMonth() - 1);
  const daysInLastMonth = new Date(date.getFullYear(), date.getMonth(), 0).getDate();

  for (let i = 0; i < firstDayInMonth; i += 1) {
    calendarCells.unshift(prepareCell(yearLastMonth, daysInLastMonth - i, false, false));
  }

  const nextMonth = new Date(date.getFullYear(), date.getMonth() + 1);
  for (let i = 0; i < cellsToAppend; i += 1) {
    calendarCells.push(prepareCell(nextMonth, i + 1, false, false));
  }

  return calendarCells;
};

export const getCalendarRows = (date: Date, currentDate: Date): Array<CalendarCell[]> => {
  const cells = getCalendarCells(date, currentDate);
  const rows: Array<CalendarCell[]> = [];

  for (let i = 0; i < cells.length; i += 7) {
    rows.push(cells.slice(i, i + 7));
  }

  return rows;
};
